import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=240183af&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=240183af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240183af",
  null
  
)

export default component.exports